import React from 'react';
import { ThemeProvider as DesignSystemThemeProvider } from '../design-system/theme/ThemeProvider';

interface ThemeProviderProps {
  children: React.ReactNode;
}

export const ThemeProvider: React.FC<ThemeProviderProps> = ({ children }) => {
  return (
    <DesignSystemThemeProvider>
      {children}
    </DesignSystemThemeProvider>
  );
};

export default ThemeProvider;